export default {"src":"/_next/static/media/workflow.356b98e8.gif","height":600,"width":1067,"blurWidth":0,"blurHeight":0};